import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import banner1 from './images/WhatsApp Image 2025-04-20 at 20.53.12_f7fb2c54.jpg';
import banner2 from './images/WhatsApp Image 2025-04-20 at 20.53.12_d8104f1d.jpg';
import banner3 from './images/WhatsApp Image 2025-04-20 at 20.53.13_fdbf02dc.jpg';
import MatchDetails from './components/MatchDetails';
import ParlayRole from './components/ParlayRole';
import WheelScreen from './components/WheelScreen';
import QuizScreen from './components/QuizScreen';
import QuizPreview from './components/QuizPreview';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import MatchSetup from './components/admin/MatchSetup';
import AddMatch from './components/admin/AddMatch';
import { ProfileProvider, useProfile } from './context/ProfileContext';
import ProtectedRoute from './components/ProtectedRoute';
import UserProfile from './components/user/UserProfile';
import UserHistory from './components/user/UserHistory';
// Dynamically load the components to avoid case sensitivity issues
import Wallet from './files/Wallet';
import Deposit from './files/Deposit';
import Withdraw from './files/Withdraw';
import WithdrawAmount from './files/WithdrawAmount';
import Mymatches from './MyMatches/Mymatches';
import MatchDetail from './MyMatches/MatchDetail';
import Match4Ka100 from './MyMatches/Match4Ka100';
import MatchParley from './MyMatches/MatchParley';
import axios from 'axios';

const LoginComponent = () => {
  const LoginModule = require('./pages/Login').default;
  return <LoginModule />;
};

const SignupComponent = () => {
  const SignupModule = require('./pages/LoginPage').default;
  return <SignupModule />;
};

function MainContent() {
  const [activeTab, setActiveTab] = useState('live');
  const [currentBanner, setCurrentBanner] = useState(0);
  const [liveMatches, setLiveMatches] = useState([]);
  const [upcomingMatches, setUpcomingMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { profile} = useProfile();

  // Check if user is logged in when component mounts
  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (!userData) {
      console.log('MainContent - No user data found, redirecting to signup');
      navigate('/signup');
    } else {
      console.log('MainContent - User data found:', JSON.parse(userData).username);
    }
  }, [navigate]);

  const banners = [
    banner1,
    banner2,
    banner3
  ];

  // Handle logout


  // Auto-scroll banner
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [banners.length]);

  // Fetch live matches
  useEffect(() => {
    const fetchLiveMatches = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/match-setup/live`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch live matches');
        }

        const data = await response.json();
        if (data.success) {
          setLiveMatches(data.data);
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching live matches:', err);
      } finally {
        setLoading(false);
      }
    };

    // Fetch initially
    fetchLiveMatches();

    // Set up polling every 30 seconds
    const interval = setInterval(fetchLiveMatches, 30000);

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  // Fetch upcoming matches
  useEffect(() => {
    const fetchUpcomingMatches = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/match-setup/upcoming`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch upcoming matches');
        }

        const data = await response.json();
        if (data.success) {
          setUpcomingMatches(data.data);
        }
      } catch (err) {
        console.error('Error fetching upcoming matches:', err);
      }
    };

    fetchUpcomingMatches();
  }, []);

  const handleMatchClick = (match) => {
    if (activeTab === 'upcoming') {
      navigate(`/match/${match._id}`, { state: { match } });
    }
  };

  const renderMatches = () => {
    if (activeTab === 'live') {
      return (
        <section className="matches-section">
          <h2 className="section-title">Live Now</h2>
          <div className="matches-grid">
            {loading ? (
              <div className="loading">Loading live matches...</div>
            ) : error ? (
              <div className="error">Error: {error}</div>
            ) : liveMatches.length === 0 ? (
              <div className="no-matches">No live matches at the moment</div>
            ) : (
              liveMatches.map(match => (
                <div key={match._id} className="match-card live">
                  <div className="match-status">{match.status}</div>
                  <div className="match-teams">
                    <div className="team">
                      <span className="team-name">{match.team1}</span>
                    </div>
                    <div className="match-info">
                      <div className="score">0:0</div>
                      <div className="match-time">{match.matchTime}</div>
                    </div>
                    <div className="team">
                      <span className="team-name">{match.team2}</span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </section>
      );
    } else {
      return (
        <section className="matches-section">
          <h2 className="section-title">Upcoming Matches</h2>
          <div className="matches-grid">
            {upcomingMatches.length === 0 ? (
              <div className="no-matches">No upcoming matches</div>
            ) : (
              upcomingMatches.map(match => (
                <div 
                  key={match._id} 
                  className="match-card upcoming"
                  onClick={() => handleMatchClick(match)}
                >
                  <div className="match-teams">
                    <div className="team team-left">
                      <span className="team-name">{match.team1}</span>
                    </div>
                    <div className="match-info">
                      <div className="vs-text">VS</div>
                      <div className="match-time">{match.matchTime}</div>
                    </div>
                    <div className="team team-right">
                      <span className="team-name">{match.team2}</span>
                    </div>
                  </div>
                  <div className="match-date">{match.matchDate}</div>
                  <button 
                    className="bet-button"
                    // onClick={(e) => {
                    //   e.stopPropagation();
                    //   navigate('/quiz', { state: { match } });
                    // }}
                    onClick={() => handleMatchClick(match)}
                  >
                    Play Games
                  </button>
                </div>
              ))
            )}
          </div>
        </section>
      );
    }
  };


  const handleProfileClick = () => {
    navigate('/profile');
  };
  const handleHistoryClick = () => {
    navigate('/history');
  };
 const handleWalletClick = () => {
    navigate('/wallet');
  };
  const handlemymatch = () => {
    navigate('/context');
  };


  const [news, setNews] = useState([{content:"🎉 Welcome to SPORTSQUERE! Get 100% bonus on your first deposit! New users get extra 50% on first deposit! 🎉"}]);
  
    useEffect(() => {
      axios.get(`${process.env.REACT_APP_BASE_URL}/api/platform/news`)
        .then((response) => {
          if(response.data.length > 0){
            setNews(response.data)
          }
        })
        .catch((error) => console.error("Error fetching news:", error));
    }, []);

  return (
    <div className="App">
      {/* Header Section */}
      <header className="header">
        <div className="header-left">
          <h1 className="site-title">CricWhizz</h1>
        </div>
        <div className="header-right">
          <div className="wallet-button">
            {/* <span className="wallet-icon">🪙</span> */}
            {/* <span className="wallet-amount">{profile.walletBalance}$</span> */}
                 <span className="wallet-amount">🪙{profile.walletBalance}</span>
          </div>
          <button className="logout-button" onClick={handleWalletClick}>
          <span role="img" aria-label="credit-card">💳</span>
          </button>
        </div>
      </header>

      {/* Flashing Message */}
      <div className="flashing-message">
        <div className="scrolling-text">
          {news[0].content}
        </div>
      </div>

      {/* Auto Scrolling Banner */}
      <div className="banner-section">
        <div className="banner-container" style={{ transform: `translateX(-${currentBanner * 100}%)` }}>
          {banners.map((banner, index) => (
            <div key={index} className="banner-slide">
              <img src={banner} alt={`Promotional Banner ${index + 1}`} className="banner-image" />
            </div>
          ))}
        </div>
        <div className="banner-dots">
          {banners.map((_, index) => (
            <button
              key={index}
              className={`banner-dot ${currentBanner === index ? 'active' : ''}`}
              onClick={() => setCurrentBanner(index)}
            />
          ))}
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="nav-tabs">

        <button 
          className={`tab-button ${activeTab === 'upcoming' ? 'active' : ''}`}
          onClick={() => setActiveTab('upcoming')}
        >
          <span className="tab-icon">📅</span> Upcoming
        </button>
        <button 
          className={`tab-button ${activeTab === 'live' ? 'active' : ''}`}
          onClick={() => setActiveTab('live')}
        >
          <span className="tab-icon">●</span> Live
        </button>
      </div>

      {renderMatches()}

      
      {/* Bottom Navigation */}
      <nav className="bottom-nav">
        <button className="nav-item active">
          <span className="nav-icon">🏠</span>
          <span>Home</span>
        </button>
        <button className="nav-item active" onClick={handlemymatch}>
          <span className="nav-icon">🎮</span>
          <span>My Matches</span>
        </button>
        <button className="nav-item active" onClick={handleHistoryClick}>
          <span className="nav-icon">📊</span>
           <span>Transactions</span>
        </button>
    
        <button className="nav-item" onClick={handleProfileClick}>
          <span className="nav-icon">👤</span>
          <span>Profile</span>
        </button>
      </nav>
    </div>
  );
}

function App() {
  // Check for user data in localStorage on initial render
  React.useEffect(() => {
    const userData = localStorage.getItem('user');
    console.log('App init - User data in localStorage:', userData ? 'exists' : 'not found');
  }, []);

  return (
    <ProfileProvider>
    <Router>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <Routes>
        {/* Public routes */}
        <Route path="/signup" element={<SignupComponent />} />
        <Route path="/login" element={<LoginComponent />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        
        {/* Protected routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <MainContent />
          </ProtectedRoute>
        } />
        <Route path="/match/:id" element={
          <ProtectedRoute>
            <MatchDetails />
          </ProtectedRoute>
        } />
        <Route path="/parlay" element={
          <ProtectedRoute>
            <ParlayRole />
          </ProtectedRoute>
        } />
        <Route path="/wheel" element={
          <ProtectedRoute>
            <WheelScreen />
          </ProtectedRoute>
        } />
        <Route path="/quiz" element={
          <ProtectedRoute>
            <QuizScreen />
          </ProtectedRoute>
        } />
        <Route path="/preview" element={
          <ProtectedRoute>
            <QuizPreview />
          </ProtectedRoute>
        } />
        {/* Temporary route - redirect quiz-question to match-detail */}
        <Route path="/quiz-question/:matchId" element={
          <ProtectedRoute>
            <Navigate to={window.location.pathname.replace('quiz-question', 'match-detail')} />
          </ProtectedRoute>
        } />
        
        {/* Admin routes - keep these protected with their own admin authentication */}
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/match-setup" element={<MatchSetup />} />
        <Route path="/admin/add-match" element={<AddMatch />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/history" element={<UserHistory />}/>

        <Route path="/wallet" element={<Wallet/>}/>
        <Route path="/deposit" element={<Deposit/>}/>
        <Route path="/withdraw" element={<Withdraw/>}/>
        <Route path="/withdraw-amount" element={<WithdrawAmount/>}/>
        <Route path='/context' element={<Mymatches/>}/>
        <Route path="/match-detail/:matchId" element={
          <ProtectedRoute>
            <MatchDetail />
          </ProtectedRoute>
        } />
        <Route path="/match-detail/:matchId/4ka100" element={
          <ProtectedRoute>
            <Match4Ka100 />
          </ProtectedRoute>
        } />
        <Route path="/match-detail/:matchId/parley" element={
          <ProtectedRoute>
            <MatchParley />
          </ProtectedRoute>
        } />
        {/* Redirect any other routes to signup */}
        <Route path="*" element={<Navigate to="/signup" replace />} />
      </Routes>
    </Router>
    </ProfileProvider>
  );
}

export default App;
